import * as React from "react";
import {PluginTemplates} from "@falcon/plugin-falcon-journey";
import {Link} from "react-router-dom";

export class WelcomePage extends React.Component {

    private pluginTemplates = new PluginTemplates();

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Welcome");
    }

    public render() {
        return (
            <React.Fragment>
                {this.pluginTemplates.renderHeader()}

                {this.pluginTemplates.renderBackButton("Go back")}

                <div className={"main-plugin"}>
                    <div className={"text-group title plugin"}>
                        <h1>Welcome to Allianz<br/>What would you like to do?</h1>
                    </div>
                    <div className={"new-quote-container plugin"}>
                        <h2>Car insurance</h2>
                        <img className={"car"} alt={"car"} src="/img/Flourishes-5.svg"/>
                        <Link className="buttonLink"
                              to="/journey/show/product/MotorInsurance/process/nb">
                            <button type="button" className="btn btn-primary btn-next plugin" id="carQuote">Start your quote</button>
                        </Link>
                        <Link className="buttonLink"
                              to="/journey/show/product/MotorInsurance/process/nb" id="carProtection">
                            <button type="button" className="btn btn-white plugin">More on car insurance</button>
                        </Link>
                    </div>
                    <div className={"retrieve-quote-container plugin"}>
                        <h2>Already saved a quote?</h2>
                        <p>Refresh your memory or make changes to your saved quote.</p>
                        <img className={"retrieve"} alt={"retrieve"} src="/img/Flourishes-6.svg"/>
                        <Link className="buttonLink" to="/retrieveQuote" id="retrieveQuote">
                            <button type="button" className="btn btn-primary btn-next plugin">My saved quote</button>
                        </Link>
                    </div>
                </div>

                {this.pluginTemplates.renderFooter()}
            </React.Fragment>
        );
    }

}
